import { isWrapper } from 'Wrapper/criticals';
import { ARTICLE, NEWS, MARKETPLACE_AUDIO_POST } from 'Constants/articleTypes';
import { isAuthCookiesSynced } from 'Wrapper/supports';

import type { ArticleTypeT } from 'Constants/articleTypes';

const ALLOWED_TYPES = new Set([ARTICLE, NEWS, MARKETPLACE_AUDIO_POST]);

export const useIsAudioAvailable = (
  duration: number | null,
  articleType?: ArticleTypeT,
): boolean => {
  const isAllowedType = articleType && ALLOWED_TYPES.has(articleType);

  if (isWrapper && !isAuthCookiesSynced) {
    return false;
  }

  return Boolean(isAllowedType && duration);
};
